/*
 * Audit Reducer
 */
import {
  GET_ALL_AUDITS,
  GET_ALL_AUDITS_SUCCESS,
  GET_ALL_AUDITS_ERROR,
  GET_USER_AUDITS,
  GET_USER_AUDITS_SUCCESS,
  GET_USER_AUDITS_ERROR,
  GET_AUDIT_TYPES,
  GET_AUDIT_TYPES_SUCCESS,
  GET_AUDIT_TYPES_ERROR,
} from './../actions/Audit';
import { CLEAR_ACTION_RESPONSE } from './../actions/Global';
import { Record, List, fromJS } from 'immutable';
import { convertAxiosSuccess, convertAxiosError } from './../utility/ConverterUtils';

/* The initial state of the App */
const AuditStateRecord = Record({
  isLoading: false,
  actionResponse: null,
  audits: null,
  allAudits: List(),
  userAudits: List(),
  auditTypes: List(),
});

const audit = (state = new AuditStateRecord({}), action) => {
  switch (action.type) {
    case GET_ALL_AUDITS:
      return auditGetAll(state);
    case GET_ALL_AUDITS_SUCCESS:
      return auditGetAllSuccess(state, action);
    case GET_ALL_AUDITS_ERROR:
      return auditGetAllError(state, action);

    case GET_USER_AUDITS:
      return auditGetForUser(state);
    case GET_USER_AUDITS_SUCCESS:
      return auditGetForUserSuccess(state, action);
    case GET_USER_AUDITS_ERROR:
      return auditGetForUserError(state, action);

    case GET_AUDIT_TYPES:
      return auditGetTypes(state);
    case GET_AUDIT_TYPES_SUCCESS:
      return auditGetTypesSuccess(state, action);
    case GET_AUDIT_TYPES_ERROR:
      return auditGetTypesError(state, action);

    case CLEAR_ACTION_RESPONSE:
      return clearActionResponse(state);

    default:
      return state;
  }
};

const auditGetAll = (state) => {
  return state.setIn(['allAudits'], state.allAudits.clear()).setIn(['isLoading'], true);
};

const auditGetAllSuccess = (state, action) => {
  return state
    .setIn(['allAudits'], fromJS(action.payload.result.audits.content))
    .setIn(['audits'], fromJS(action.payload.result.audits))
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const auditGetAllError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const auditGetForUser = (state) => {
  return state.setIn(['userAudits'], state.userAudits.clear()).setIn(['isLoading'], true);
};

const auditGetForUserSuccess = (state, action) => {
  return state
    .setIn(['audits'], fromJS(action.payload.result.audits))
    .setIn(['userAudits'], fromJS(action.payload.result.audits.content))
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const auditGetForUserError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const auditGetTypes = (state) => {
  return state.setIn(['auditTypes'], state.auditTypes.clear()).setIn(['isLoading'], true);
};

const auditGetTypesSuccess = (state, action) => {
  return state
    .setIn(['auditTypes'], fromJS(action.payload.result.auditTypes))
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const auditGetTypesError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

/** Clears the reducer errors */
const clearActionResponse = (state) => {
  return state.setIn(['actionResponse'], null);
};

export default audit;
